import { render } from "./payroll-filter.vue?vue&type=template&id=13e2fb4b"
import script from "./payroll-filter.vue?vue&type=script&lang=js"
export * from "./payroll-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__